type WithAddress<A> = {
  address?: A | null
  order?: { site?: { address?: A | null } | null } | null
}

/** v1: a stop's address is the waypoint's own; the order site only covers a
 * bare order. Shared by the stop card and the map navigation so they agree. */
export const waypointAddress = <A>(waypoint: WithAddress<A>): A | null =>
  waypoint.address ?? waypoint.order?.site?.address ?? null
